import React, { Component, Fragment } from "react";
import AppContext from "../../contexts/AppContext";
import OnboardingSteps from "./include/OnboardingSteps";
import "./include/SelectPlan.css"
import { getCheckoutStepsData, updateUserData, updateUserWithToken,completeSelectPlanStep} from "../../services/user";
import ReactTooltip from "react-tooltip";
export class SelectPlan extends Component {
    constructor(){
        super();
        this.state = {
            loading: false,
            choose_plan:'',
        }
    }
    handleSubmit = type => e => {
        e.preventDefault();
        this.setState({ loading: true, choose_plan:type });
        completeSelectPlanStep({ token: "", type: type })
            .then(res => {
                console.log(res);
                if (res.status === true) {
                    this.setState({ loading: false });
                    if(res.data.steps === 'account'){
                        localStorage.setItem("user_steps", "account");
                        this.props.history.push('/account');
                    }else{
                        localStorage.setItem("user_steps", "billing");
                        this.props.history.push('/process/billing');
                    }
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });
       
    }
    componentDidMount() {
        this.context.state.updateMetaData('select-plan');
        window.scrollTo(0, 0);
        // getCheckoutStepsData({ token: "", type: 'pwonbs1' })
        //     .then(res => {
        //         if (res.status === true) {
                    
        //             // this.setState({
        //             //     item: res.data,
        //             //     industry: res.meta.industries,
        //             //     whyPWReason: res.meta.checkout_steps_data.whyPw,
        //             //     roles: res.meta.categories,
        //             //     freelancingExperienceList: res.meta.checkout_steps_data.freelanceWritingExperience,
		// 			// 	how_did_you_find_us_options: res.meta.checkout_steps_data.howDidYouHear,
        //             // });
        //            // console.log(this.state.whyPWReason);
        //         } else {
        //             this.setState({ validToken: false });
        //         }
        //     })
        //     .catch(error => {
        //         this.setState({ validToken: false });
        //     });
    }
	
    render() {
        return (
            <Fragment>
			    <section className="checkout-process resp-checkout-process py-md-6 py-sm-5 py-4">
				    <div className="container">	
					    <div className="sub-container mx-auto">
				            <div className="row no-gutters">
				                <div className="col-xl-3 col-lg-4 col-md-4">
				            	    <OnboardingSteps onboardStep="[1,2,3]" show="3"></OnboardingSteps>
				            	</div>
				            	<div className="col-xl-9 col-lg-8 col-md-8">
				            	    <div className="bg-white checkout new">
									    <div className="create-profile mx-auto mb-3 p-0">
                                            <div className="title select-plan-title">
											    <img className="mx-auto d-block mb-3" width="30" height="46" src="/images/logo_dark.png" alt="pw-logo"/>
												<h2 className="text-center mb-3">Choose your ProWriter plan</h2>
												<p className="text-center mb-4">We have plans for new and professional freelance writer budgets</p>
											</div>
                                            <div className="select-plan-container row">
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="select-plan-wrapper mb-4">
                                                        <span className="popular-badge">MOST POPULAR</span>
                                                        <div class="offer-ribbon-wrapper">
                                                            <div class="offer-ribbon">50% OFF*</div>
                                                        </div>
                                                      <div className="select-plan-header">
                                                          <p className="plan-type">Plus</p>
                                                          <h2>
                                                              <span class="strike-price">$94 <sub>/ year</sub></span>
                                                              <span class="offer-price">$47 <sub></sub></span>
                                                          </h2>
                                                          <p className="plan-info">For writers looking to earn more income and amplify their writing careers.</p>
                                                      </div>
                                                      <div className="select-plan-list">
                                                          <ul>
                                                              <li><div><span className="fa fa-check"></span></div>Premium Writer Portfolio</li>
                                                              <li><div><span className="fa fa-check"></span></div>Apply to jobs + boosted visibility<span className="why-cc" data-tip data-for='plan1'><i className="fa fa-question-circle mr-1"></i></span>
                                                              <ReactTooltip id='plan1' className='why-cc-tooltip' arrowColor='#efba00'>
																<span className="tooltip-plan">You'll appear at the top of the application list</span>
									                          </ReactTooltip>
                                                              </li>
                                                               <li><div><span className="fa fa-check"></span></div>Real-time job alerts</li>
                                                               <li><div><span className="fa fa-check"></span></div>Exclusive Writer Community</li>
                                                              {/* <Tooltip placement="top" isOpen={this.state.tooltipOpen} target="Tooltip1" toggle={this.toggle}>You'll appear at the top of the application list</Tooltip> */}
                                                              <li><div><span className="fa fa-check"></span></div>Verified Writer badge on Portfolio<span className="why-cc" data-tip data-for='plan2'><i className="fa fa-question-circle mr-1"></i></span>
                                                              <ReactTooltip id='plan2' className='why-cc-tooltip' arrowColor='#efba00'>
																<span className="tooltip-plan">We verify your identity and skills. Verified writers see 10x response rates.</span>
									                          </ReactTooltip>
                                                              </li>
                                                              <li><div><span className="fa fa-check"></span></div>Message directly with employers</li>
                                                              <li><div><span className="fa fa-check"></span></div>See who's viewed your portfolio</li>
                                                              <li><div><span className="fa fa-check"></span></div>Courses, Guides, & Certifications</li>
                                                          </ul>
                                                      </div>
                                                      <div className="select-plan-btn">
                                                          <button className="btn-primary" onClick={this.handleSubmit("select-plan")} disabled={this.state.loading} >
                                                          <i className={this.state.loading && this.state.choose_plan == 'select-plan' ? `mr-2 fas fa-spinner fa-spin` : ``}></i> {this.state.loading && this.state.choose_plan == 'select-plan' ? `Processing...` : `Choose Plan`}
                                                          </button>
                                                          <p className="discount-text">*First year $47 (50% off), then just $94/year.</p>
                                                      </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-lg-6">
                                                    <div className="select-plan-wrapper">
                                                      <div className="select-plan-header">
                                                          <p className="plan-type">Basic</p>
                                                          <h2>Free</h2>
                                                          <p className="plan-info">For new writers looking to launch their writing careers and start earning income.</p>
                                                      </div>
                                                      <div className="select-plan-list">
                                                          <ul>
                                                              <li><div><span className="fa fa-check"></span></div>Standard Writer Portfolio</li>
                                                              <li>< div><span className="fa fa-check"></span></div>Apply to jobs</li>
                                                              <li>< div><span className="fa fa-check"></span></div>Daily jobs digest</li>
                                                              <li>< div><span className="fa fa-times"></span></div>Exclusive Writer Community</li>
                                                              <li><div><span className="fa fa-times"></span></div>Verified Writer badge on Portfolio<span className="why-cc" data-tip data-for='plan2'>
                                                                {/* <i className="fa fa-question-circle mr-1"></i> */}
                                                            </span>
                                                              {/* <ReactTooltip id='plan2' className='why-cc-tooltip' arrowColor='#efba00'>
																<span className="tooltip-plan">We verify your identity and skills. Verified writers see 10x response rates.</span>
									                          </ReactTooltip> */}
                                                              </li>
                                                              <li><div><span className="fa fa-times"></span></div>Message directly with employers</li>
                                                              <li><div><span className="fa fa-times"></span></div>See who's viewed your portfolio</li>
                                                              <li><div><span className="fa fa-times"></span></div>Courses, Guides, & Certifications</li>
                                                          </ul>
                                                      </div>
                                                      <div className="select-plan-btn choose-plan-btn">
                                                          <button className="btn-primary" onClick={this.handleSubmit("free")} disabled={this.state.loading} >
                                                          <i className={this.state.loading && this.state.choose_plan == 'free' ? `mr-2 fas fa-spinner fa-spin` : ``}></i> {this.state.loading && this.state.choose_plan == 'free' ? `Processing...` : `Choose Plan`}
                                                          </button>
                                                      </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
									</div>
				            	</div>
				            </div>
						</div>	
					</div>
				</section>
			</Fragment>
        )
    }
}

SelectPlan.contextType = AppContext;
export default SelectPlan;	


// WEBPACK FOOTER //
// ./src/components/general/SelectPlan.js